import { Box, Typography } from '@mui/material';
import '../EnvironmentBanner.css';
import appConfig from '../config/appConfig';
const EnvironmentBanner = ({ title, identifier, children }) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(identifier);
  };

  const ENV_CONFIG = {
    staging: {
      label: 'Staging',
      message: 'You are testing in staging',
    },
    sandbox: {
      label: 'Sandbox',
      message: 'You are testing in a sandbox',
    },
  };

  const env = appConfig.appEnvBanner?.toLowerCase();
  if (env === 'production' || env === '') {
    return null;
  }
  const config = ENV_CONFIG[env] ? ENV_CONFIG[env] : { label: env, message: '' };

  return (
    <Box direction="row" component="div" className="environment-banner">
      <Typography component="div" className="env-leftcontent">
        {config.label}
      </Typography>
      <Typography component="div" className="env-centercontent">
        {config.message}
      </Typography>
    </Box>
  );
};

export default EnvironmentBanner;
